// jshint esversion: 8

export default {
  byTrip: state => id => state.data.filter(email => email.trip === id)
};
